module.exports = __webpack_public_path__ + "0a378a49.svg";